import { useTranslation } from "react-i18next";

import Footer from "../../core/Footer";

const ForbiddenPage = () => {
    const { t } = useTranslation('errors');

    return (
        <div className="height-100">
            <div className="h-100 d-flex flex-column justify-content-center align-items-center">
                <img
                    alt="forbidden"
                    src={`${process.env.PUBLIC_URL}/images/errors/forbidden.svg`} />
                <h1 className="c-dark-blue fw-semi-bold">{t("forbidden")}</h1>
                <div className="text-center w-75">
                    <span className="c-dark-blue">
                        {t("forbidden_content")}
                    </span>
                </div>
            </div>
            <div className="footer-bottom">
                <Footer />
            </div>
        </div>);
}

export default ForbiddenPage;